export const infoSnowRestApiData = async (err) => {
  if (err) {
    console.error(err);
  }
  const blogId = document.getElementsByTagName('html')[0].id;
  // Check if is pradaschier website and if is info page
  if (
    blogId === 'blog-5' &&
    document.getElementsByClassName('accordion__infosnow').length > 0
  ) {
    var url = 'URL not found';

    if (
      document.getElementsByClassName('accordion__infosnow-summer').length > 0
    ) {
      var isSummer = true;
      console.log(isSummer);
      url =
        'https://corsproxy.io/?key=3191aff3&url=' +
        encodeURIComponent(
          'https://infosnow.ch/~apgmontagne/?type=xml&id=57&report=1552&ref=3517518b5e47dbf7b2296c8a60b0ed99',
        );
    } else {
      var isWinter = true;
      url =
        'https://corsproxy.io/?key=3191aff3&url=' +
        encodeURIComponent(
          'https://infosnow.ch/~apgmontagne/?type=xml&id=57&report=1546&ref=45fe54677d64a19d1bb7b28ddd741d42',
        );
    }

    fetch(url, {
      method: 'GET',
      mode: 'cors',
    })
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onload = function (event) {
          const xmlText = event.target.result,
            parser = new DOMParser(),
            xmlDoc = parser.parseFromString(xmlText, 'text/xml'),
            // Opening hours
            openingHourFrom = xmlDoc.getElementsByTagName(
              'SKDailyFacilitiesOpenedFrom',
            )[0].childNodes[0].nodeValue,
            openingHourUntil = xmlDoc.getElementsByTagName(
              'SKDailyFacilitiesOpenedTo',
            )[0].childNodes[0].nodeValue,
            // Bergbahnen und Lifte operational status
            openFacilities = xmlDoc.getElementsByTagName(
              'SKDailyNumberOfOpenFacilities',
            )[0].childNodes[0].nodeValue,
            totalFacilities = xmlDoc.getElementsByTagName(
              'SKDailyNumberOfFacilities',
            )[0].childNodes[0].nodeValue,
            // Parks operational status
            /*             openParks = xmlDoc.getElementsByTagName(
              'SBDailyParkOpenedToday',
            )[0].childNodes[0].nodeValue,
            totalParks = xmlDoc.getElementsByTagName(
              'SBDailyPark',
            )[0].childNodes[0].nodeValue, */
            openFacilitiesContainer = document.createElement('div'),
            openSlopesContainer = document.createElement('div'),
            openWegeUndParksContainer = document.createElement('div'),
            openRestaurantsContainer = document.createElement('div'),
            lifteContainer = document.querySelector(
              '#bergbahnen-und-lifte > .wp-block-group > .wp-block-group',
            ),
            slopesContainer = document.querySelector(
              '#pisten > .wp-block-group > .wp-block-group',
            ),
            wegeUndParksContainer = document.querySelector(
              '#wege-und-parks > .wp-block-group > .wp-block-group',
            ),
            restaurantsContainer = document.querySelector(
              '#restaurants > .wp-block-group > .wp-block-group',
            );

          if (isWinter) {
            // Slopes operational status
            var totalSlopes =
                xmlDoc.getElementsByTagName('SKDailySlopesCount')[0]
                  .childNodes[0].nodeValue,
              openSlopes = xmlDoc.getElementsByTagName(
                'SKDailySlopesOpenCount',
              )[0].childNodes[0].nodeValue;
          }

          openFacilitiesContainer.className = 'openAndTotalUnits';
          openSlopesContainer.className = 'openAndTotalUnits';
          openWegeUndParksContainer.className = 'openAndTotalUnits';
          openRestaurantsContainer.className = 'openAndTotalUnits';

          if (openFacilities === totalFacilities) {
            openFacilitiesContainer.classList.add('all-open');
          }
          if (openSlopes === totalSlopes) {
            openSlopesContainer.classList.add('all-open');
          }
          if (openFacilities < totalFacilities && openFacilities > 0) {
            openFacilitiesContainer.classList.add('some-open');
          }
          if (openSlopes < totalSlopes && openSlopes > 0) {
            openSlopesContainer.classList.add('some-open');
          }
          if (openFacilities == '0') {
            openFacilitiesContainer.classList.add('none-open');
          }
          if (openSlopes == '0') {
            openSlopesContainer.classList.add('none-open');
          }
          openFacilitiesContainer.innerHTML = ` ${openFacilities} von ${totalFacilities} Anlagen in Betrieb`;
          lifteContainer.parentElement.parentElement.prepend(
            openFacilitiesContainer,
          );
          openSlopesContainer.innerHTML = ` ${openSlopes} von ${totalSlopes} Pisten in Betrieb`;
          if (slopesContainer) {
            slopesContainer.parentElement.parentElement.prepend(
              openSlopesContainer,
            );
          }

          //
          // Restaurants and Parks status badges
          //
          var totalParks = 0,
            openParks = 0,
            totalRestaurants = 0,
            openRestaurants = 0;
          setTimeout(() => {
            (totalParks = document.querySelectorAll(
              '#wege-und-parks .wp-block-group .wp-block-group .infoSnowRow',
            ).length),
              // Get all parks with class closed
              (openParks = document.querySelectorAll(
                '#wege-und-parks .wp-block-group .wp-block-group .infoSnowRow .infoSnowRow__col.open',
              ).length);

            (totalRestaurants = document.querySelectorAll(
              '#restaurants .wp-block-group .wp-block-group .infoSnowRow',
            ).length),
              // Get all parks with class closed
              (openRestaurants = document.querySelectorAll(
                '#restaurants .wp-block-group .wp-block-group .infoSnowRow .infoSnowRow__col.open',
              ).length);

            openWegeUndParksContainer.innerHTML = ` ${openParks} von ${totalParks} Anlagen in Betrieb`;
            openRestaurantsContainer.innerHTML = ` ${openRestaurants} von ${totalRestaurants} Restaurants in Betrieb`;
            wegeUndParksContainer.parentElement.parentElement.prepend(
              openWegeUndParksContainer,
            );
            restaurantsContainer.parentElement.parentElement.prepend(
              openRestaurantsContainer,
            );

            if (openParks == '0') {
              openWegeUndParksContainer.classList.add('none-open');
            }

            if (openParks < totalParks && openParks > 0) {
              openWegeUndParksContainer.classList.add('some-open');
            }

            if (openParks === totalParks) {
              openWegeUndParksContainer.classList.add('all-open');
            }

            if (openRestaurants == '0') {
              openRestaurantsContainer.classList.add('none-open');
            }

            if (openRestaurants < totalRestaurants && openRestaurants > 0) {
              openRestaurantsContainer.classList.add('some-open');
            }

            if (openRestaurants === totalRestaurants) {
              openRestaurantsContainer.classList.add('all-open');
            }
          }, 1000);

          //console.log(xmlDoc);
          //
          // Bergbahnen und Lifte
          //
          xmlDoc.querySelectorAll('[name="ANLAGE"]').forEach((anlagen) => {
            anlagen.childNodes.forEach((anlageElemente) => {
              var innerDiv = document.createElement('div'),
                anlageName = '',
                laengeGesamt = '',
                hoehenmeter = '',
                reiseDauer = '';
              innerDiv.className = 'infoSnowRow';
              //console.log('Anlagen:', anlageElemente);
              anlageElemente.childNodes.forEach((anlageElement) => {
                if (anlageElement.nodeName === 'TypID') {
                  innerDiv.innerHTML += `<div class="infoSnowRow__col"><img src="/wp-content/themes/alpintrend/resources/images/APG_Iconset/${anlageElement.childNodes[0].nodeValue}.svg" /></div>`;
                }
              });
              anlageElemente.childNodes.forEach((anlageElement) => {
                if (anlageElement.nodeName === 'Name') {
                  anlageName = anlageElement.childNodes[0].nodeValue;
                }
                if (anlageElement.nodeName === 'LaengeGesamt') {
                  laengeGesamt = `<span><h6>Länge</h6><p>${anlageElement.childNodes[0].nodeValue} m</p></span>`;
                }

                if (anlageElement.nodeName === 'heightMountain') {
                  hoehenmeter = `<span><h6>Höhenmeter</h6><p>${anlageElement.childNodes[0].nodeValue} m</p></span>`;
                }
                if (anlageElement.nodeName === 'travelTime') {
                  reiseDauer = `<span><h6>Dauer</h6><p>${anlageElement.childNodes[0].nodeValue} min.</p></span>`;
                }

                //console.log(anlageElement.childNodes[0]);
              });

              innerDiv.innerHTML += `<div class="infoSnowRow__col"><h4>${anlageName} </h4><p class="operation-hours">Betriebszeiten: ${openingHourFrom.slice(0, -3)} - ${openingHourUntil.slice(0, -3)}</p><div class="anlage-properties">${laengeGesamt} ${reiseDauer} ${hoehenmeter} </div></div>`;

              anlageElemente.childNodes.forEach((anlageElement) => {
                if (anlageElement.nodeName === 'StatusID') {
                  let statusName = anlageStatusName(
                    parseInt(anlageElement.childNodes[0].nodeValue),
                  );

                  innerDiv.innerHTML += `<div class="infoSnowRow__col ${anlageStatusClass(statusName)}">${statusName}</div>`;
                }
              });

              lifteContainer.appendChild(innerDiv);
            });
          });

          //
          // Pisten
          //

          if (slopesContainer) {
            xmlDoc
              .querySelectorAll('[name="SKIPISTE"]')
              .forEach((skipisten) => {
                skipisten.childNodes.forEach((skipistenElemente) => {
                  var innerDiv = document.createElement('div');
                  innerDiv.className = 'infoSnowRow';
                  skipistenElemente.childNodes.forEach((skipisteElement) => {
                    if (skipisteElement.nodeName === 'TypID') {
                      innerDiv.innerHTML += `<div class="infoSnowRow__col"><img src="/wp-content/themes/alpintrend/resources/images/APG_Iconset/${skipisteElement.childNodes[0].nodeValue}.svg" /></div>`;
                    }
                  });
                  var skipisteName = '',
                    laengeGesamt = '',
                    skipisteNr = '';
                  skipistenElemente.childNodes.forEach((skipisteElement) => {
                    if (skipisteElement.nodeName === 'Initial') {
                      skipisteNr = skipisteElement.childNodes[0].nodeValue;
                    }
                    if (skipisteElement.nodeName === 'Name') {
                      skipisteName = skipisteElement.childNodes[0].nodeValue;
                    }
                    if (skipisteElement.nodeName === 'LaengeGesamt') {
                      laengeGesamt = `<h6>Länge</h6><p>${skipisteElement.childNodes[0].nodeValue} m</p>`;
                    }
                  });

                  innerDiv.innerHTML += `<div class="infoSnowRow__col"><h4>${skipisteNr} - ${skipisteName} </h4>${laengeGesamt}</div>`;

                  skipistenElemente.childNodes.forEach((skipisteElement) => {
                    if (skipisteElement.nodeName === 'StatusID') {
                      let statusName = anlageStatusName(
                        parseInt(skipisteElement.childNodes[0].nodeValue),
                      );

                      innerDiv.innerHTML += `<div class="infoSnowRow__col ${anlageStatusClass(statusName)}">${statusName}</div>`;
                    }
                  });

                  slopesContainer.appendChild(innerDiv);
                });
              });
          }

          //
          // Wege und Parks
          // Schlittelwege
          //
          xmlDoc
            .querySelectorAll('[name="SCHLITTELWEG"]')
            .forEach((schlittelwege) => {
              schlittelwege.childNodes.forEach((schlittelwegeElemente) => {
                var innerDiv = document.createElement('div');

                innerDiv.className = 'infoSnowRow';
                schlittelwegeElemente.childNodes.forEach(
                  (schlittelwegElement) => {
                    if (schlittelwegElement.nodeName === 'TypID') {
                      innerDiv.innerHTML += `<div class="infoSnowRow__col"><img src="/wp-content/themes/alpintrend/resources/images/APG_Iconset/${schlittelwegElement.childNodes[0].nodeValue}.svg" /></div>`;
                    }
                  },
                );
                var schlittelwegName = '',
                  laengeGesamt = '',
                  betriebszeiten = '';

                schlittelwegeElemente.childNodes.forEach(
                  (schlittelwegElement) => {
                    if (schlittelwegElement.nodeName === 'Name') {
                      schlittelwegName =
                        schlittelwegElement.childNodes[0].nodeValue;
                    }
                    if (schlittelwegElement.nodeName === 'LaengeGesamt') {
                      laengeGesamt =
                        schlittelwegElement.childNodes[0].nodeValue;
                    }

                    if (schlittelwegElement.nodeName === 'oeffnungszeiten') {
                      // Get element zeiten from array
                      schlittelwegElement.childNodes.forEach(
                        (zeitenElement) => {
                          if (zeitenElement.nodeName === 'zeitraum') {
                            betriebszeiten =
                              zeitenElement.childNodes[2].childNodes[0]
                                .nodeValue;
                          }
                        },
                      );
                    }
                  },
                );

                //console.log('betriebszeiten:', betriebszeiten);

                innerDiv.innerHTML += `<div class="infoSnowRow__col"><h4>${schlittelwegName} </h4><p class="operation-hours">Betriebszeiten: ${betriebszeiten} Uhr</p><div class="anlage-properties"><span><h6>Länge</h6><p>${laengeGesamt} m</p></span></div></div>`;

                schlittelwegeElemente.childNodes.forEach(
                  (schlittelwegElement) => {
                    if (schlittelwegElement.nodeName === 'StatusID') {
                      let statusName = anlageStatusName(
                        parseInt(schlittelwegElement.childNodes[0].nodeValue),
                      );

                      innerDiv.innerHTML += `<div class="infoSnowRow__col ${anlageStatusClass(statusName)}">${statusName}</div>`;

                      if (
                        schlittelwegElement.childNodes[0].nodeValue === '1' ||
                        schlittelwegElement.childNodes[0].nodeValue === '8'
                      ) {
                        innerDiv
                          .getElementsByClassName('infoSnowRow__col')[2]
                          .classList.add('open');
                      }
                    }
                  },
                );

                wegeUndParksContainer.appendChild(innerDiv);
              });
            });
          //
          // Parks
          //
          xmlDoc.querySelectorAll('[name="PARK"]').forEach((parks) => {
            parks.childNodes.forEach((parksElemente) => {
              var innerDiv = document.createElement('div');
              innerDiv.className = 'infoSnowRow';
              parksElemente.childNodes.forEach((parksElement) => {
                if (parksElement.nodeName === 'TypID') {
                  innerDiv.innerHTML += `<div class="infoSnowRow__col"><img src="/wp-content/themes/alpintrend/resources/images/APG_Iconset/${parksElement.childNodes[0].nodeValue}.svg" /></div>`;
                }
              });
              var parkName = '',
                laengeGesamt = '',
                betriebszeiten = '';

              parksElemente.childNodes.forEach((parksElement) => {
                if (parksElement.nodeName === 'Name') {
                  parkName = parksElement.childNodes[0].nodeValue;
                }
                if (parksElement.nodeName === 'LaengeGesamt') {
                  laengeGesamt = `<div class="anlage-properties"><span><h6>Länge</h6><p> ${parksElement.childNodes[0].nodeValue} m</p></span></div>`;
                }
                if (parksElement.nodeName === 'oeffnungszeiten') {
                  // Get element zeiten from array
                  parksElement.childNodes.forEach((zeitenElement) => {
                    if (zeitenElement.nodeName === 'zeitraum') {
                      betriebszeiten = `<p class="operation-hours">Betriebszeiten:  ${zeitenElement.childNodes[2].childNodes[0].nodeValue} Uhr</p>`;
                    }
                  });
                }
              });

              // console.log('betriebszeiten:', betriebszeiten);

              innerDiv.innerHTML += `<div class="infoSnowRow__col"><h4>${parkName} </h4>${betriebszeiten} ${laengeGesamt} </div>`;

              parksElemente.childNodes.forEach((parksElement) => {
                if (parksElement.nodeName === 'StatusID') {
                  let statusName = anlageStatusName(
                    parseInt(parksElement.childNodes[0].nodeValue),
                  );

                  innerDiv.innerHTML += `<div class="infoSnowRow__col ${anlageStatusClass(statusName)}">${statusName}</div>`;

                  if (
                    parksElement.childNodes[0].nodeValue === '1' ||
                    parksElement.childNodes[0].nodeValue === '8'
                  ) {
                    innerDiv
                      .getElementsByClassName('infoSnowRow__col')[2]
                      .classList.add('open');
                  }
                }
              });

              wegeUndParksContainer.appendChild(innerDiv);
            });
          });
          //
          // Restaurants
          //
          xmlDoc
            .querySelectorAll('[name="RESTAURANT"]')
            .forEach((restaurants) => {
              restaurants.childNodes.forEach((restaurantsElemente) => {
                var innerDiv = document.createElement('div');
                innerDiv.className = 'infoSnowRow';
                restaurantsElemente.childNodes.forEach((restaurantElement) => {
                  if (restaurantElement.nodeName === 'TypID') {
                    innerDiv.innerHTML += `<div class="infoSnowRow__col"><img src="/wp-content/themes/alpintrend/resources/images/APG_Iconset/${restaurantElement.childNodes[0].nodeValue}.svg" /></div>`;
                  }
                });
                var restaurantName = '';

                restaurantsElemente.childNodes.forEach((restaurantElement) => {
                  if (restaurantElement.nodeName === 'Name') {
                    restaurantName = restaurantElement.childNodes[0].nodeValue;
                  }
                });

                innerDiv.innerHTML += `<div class="infoSnowRow__col"><h4>${restaurantName} </h4></div>`;

                restaurantsElemente.childNodes.forEach((restaurantElement) => {
                  if (restaurantElement.nodeName === 'StatusID') {
                    let statusName = anlageStatusName(
                      parseInt(restaurantElement.childNodes[0].nodeValue),
                    );

                    innerDiv.innerHTML += `<div class="infoSnowRow__col ${anlageStatusClass(statusName)}">${statusName}</div>`;
                  }
                });

                restaurantsContainer.appendChild(innerDiv);
              });
            });
        };
        reader.readAsText(blob);
      })
      .catch((err) => {
        console.log('Something went wrong!', err);
      });
  }

  function anlageStatusName(StatusID = 0) {
    var statusName = '';
    switch (StatusID) {
      case 0:
        statusName = 'no info';
        break;
      case 1:
        statusName = 'offen';

        break;
      case 2:
        statusName = 'in Vorbereitung';
        break;
      case 3:
        statusName = 'geschlossen aus technischen Gründen';
        break;
      case 5:
        statusName = 'geschlossen aus betrieblichen Gründen';
        break;
      case 6:
        statusName = 'geschlossen aus atmosphärischen Gründen';
        break;
      case 7:
        statusName = 'außer Betrieb';
        break;
      case 8:
        //statusName = 'open (deprecated)';
        statusName = 'offen';
        break;
      case 9:
        statusName = 'in Vorbereitung';
        break;
      case 10:
        statusName = 'geschlossen, Lawinengefahr';
        break;
      case 11:
        statusName = 'geschlossen, Gefahr von Eis/Hart';
        break;
      case 12:
        statusName = 'geschlossen, Gefahr von Wind/Kälte';
        break;
      case 13:
        statusName = 'geschlossen, Gefahr von Sturm';
        break;
      case 14:
        //statusName = 'out of service (deprecated)';
        statusName = 'außer Betrieb';
        break;
      case 15:
        statusName = 'geschlossen';
        break;
      case 16:
        statusName = 'geschlossen';
        break;
      case 17:
        statusName = 'Ruhetag';
        break;
      case 18:
        statusName = 'Betriebsferien';
        break;
      default:
        statusName = 'geschlossen';
    }

    return statusName;
  }
  function anlageStatusClass(statusName) {
    let statusClass = '';
    if (statusName === 'offen') {
      statusClass = 'open';
    }
    if (statusName === 'in Vorbereitung') {
      statusClass = 'in-preparation';
    }
    if (
      statusName === 'geschlossen' ||
      statusName === 'geschlossen' ||
      statusName === 'Ruhetag' ||
      statusName === 'geschlossen, Gefahr von technischen Gründen' ||
      statusName === 'außer Betrieb' ||
      statusName === 'geschlossen, Gefahr von betrieblichen Gründen' ||
      statusName === 'geschlossen, Gefahr von atmosphärischen Gründen' ||
      statusName === 'geschlossen, Gefahr von Lawinen' ||
      statusName === 'geschlossen, Gefahr von Eis/Hart' ||
      statusName === 'geschlossen, Gefahr von Wind/Kälte' ||
      statusName === 'außer Betrieb'
    ) {
      statusClass = 'closed';
    }
    return statusClass;
  }
};

import.meta.webpackHot?.accept(infoSnowRestApiData);
